<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <template v-if="true">
      <div class="text__view flex flex-col justify-center text-center mb-5">
        <h1 class="font-semibold text-2xl my-5">
          {{ discover_subtitle?.title }}
        </h1>
        <p class="leading-6 max-w-5xl mx-auto">
          {{ discover_subtitle?.subtitle.split("|")[0] }}
          <a class="italic text-gray-600" href="/our-process" target="_blank">{{
            discover_subtitle?.subtitle.split("|")[1]
          }}</a>

          {{ discover_subtitle?.subtitle.split("|")[2] }}
        </p>
      </div>
      <div class="italic flex flex-col justify-center text-center mb-5 text-xl my-10">
        <vue-countdown :time="time_difference" v-slot="{ days, hours, minutes, seconds }">
          <template v-if="roleUser == 'free'">
            <div class="flex inline-flex">
              <router-link to="/pricing">
                <Button class="px-8 bg-indigo-600 hover:bg-indigo-500 text-white">Join Today</Button>
              </router-link>
            </div>

            and don’t miss out the next 100+ top FB ads in {{ days }} days,
            {{ hours }} hours, {{ minutes }} minutes, {{ seconds }} seconds.
          </template>
          <template v-else>
            100+ new ads coming in {{ days }} days, {{ hours }} hours,
            {{ minutes }} minutes, {{ seconds }} seconds.
          </template>
        </vue-countdown>
        <div v-if="roleUser == 'free'" class="xl:col-start-1 xl:col-end-4"></div>
      </div>

      <Filters :active_filters="{
        industry: true,
        platform: true,
        format: true,
        month: true,
      }" class="hidden xl:grid grid-cols-13 grid-flow-col justify-center items-center" />
      <template v-if="ads && ads.length">
        <div class="library__list py-4 lg:py-10 items-start">
          <template v-for="ad in ads" :key="ad.id">
            <template v-if="ad.original == 'facebook'">
              <Ad :data="ad" class="library__item" :isCollection="false" />
            </template>
            <template v-else>
              <TiktokVideo :data="ad" class="library__item" :isCollection="false" />
            </template>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto">
          <div>
            <h2 class="text-4xl font-semibold mb-4">
              Looking for FB, IG and TIKTOK ads 👀
            </h2>
            <p class="mb-10 text-lg">
              We recommend to clean the filters
            </p>
            <div class="flex justify-center">
              <Button @click="getInitialAds()" class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white">Clean
                filters</Button>
            </div>
          </div>
        </div>
      </template>
    </template>
    <Pagination :totalElements="totalDiscover" :pageView="page" />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
//import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import Ad from "@/components/Ad/index";
import TiktokVideo from "@/components/TiktokVideo/index";
import Button from "@/components/UI/Button";
import Filters from "@/components/Filters";
import Pagination from "@/components/Pagination";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    HeaderApp,
    Ad,
    TiktokVideo,
    AdblockTopbar,
    Button,
    Pagination,
    Filters,
    VueCountdown,
  },
  methods: {},
  setup() {
    const store = useStore();

    let advertisements = computed(() => store.state.advertisements);
    let tiktoks = computed(() => store.state.tiktoks);
    const ads = computed(() => {
      let ads = [];
      for (let i = 0; i < store.state.adsPerPage; i++) {
        if (advertisements.value && advertisements.value[i]) {
          ads.push(advertisements.value[i]);
          ads[ads.length - 1].original = 'facebook';
        }
        if (tiktoks.value && tiktoks.value[i]) {
          ads.push(tiktoks.value[i]);
          ads[ads.length - 1].original = 'tiktoks';
        }
      }
      return ads;
    });
    const totalDiscover = computed(() => store.state.totalDiscover);
    const discover_subtitle = computed(() => store.state.discoverSubtitle);
    const page = computed(() => store.state.page);
    const roleUser = computed(() => store.state.role);
    const getInitialAds = () => {
      store.commit("CLEAN_FILTERS");
    };

    var now = new Date();
    var next_month = new Date(now.getFullYear(), now.getMonth() + 1, 1);

    next_month.setHours(12);
    next_month.setMinutes(1);
    let time_difference = next_month - now;

    return {
      roleUser,
      totalDiscover,
      page,
      getInitialAds,
      discover_subtitle,
      time_difference,
      ads,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}

.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
